<app-trips-audit-grid (mySelected)='grid_onSelected($event)'></app-trips-audit-grid>
